export default __webpack_public_path__ + "static/media/mon_256.cbd71572.png";